import { DropdownOption } from '../../definitions/DropdownOption';

export const NO_SURGEON_DROPDOWN: DropdownOption = {
	value: 'none',
	label: 'No Surgeon'
};

export const NO_SURGEON_VALUE = NO_SURGEON_DROPDOWN.value;
